export const OPTION_TYPE_IDS_MEDIUM_12 = [
    1, // FORMAT
    3, // MATERIAL
];

export default {
    name: "optionWidth.js",
    methods: {
        optionWidthClass( option ) {
            if( option.values.some(v => v.caption.length > 20) || OPTION_TYPE_IDS_MEDIUM_12.some(v => v == option.typeId) )
            {
                return 'medium-12'
            }
            return 'medium-6'
        }
    }
}
